import React from 'react';
import KYBCompanyInfo from 'assets/images/company/company-links.svg';
import { useTranslation } from 'react-i18next';
import { Tabs, Row, Col } from 'antd';
import TabTitle from '../../TabTitle';
import TreeTableCompanyLinks from './components/TreeTable';

import './styles.less';

const I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.subPages.companyLinks';
const { TabPane } = Tabs;

const GroupStructure = ({ companyLinksData }) => {
  const { t: translate } = useTranslation();

  return (
    <aside className="group-structure-tab">
      <Row gutter={15}>
        <Col span={12} className="company-link-group-col">
          <Row className="company-link-group-card">
            <Row>
              <Col span={24}>
                <p className="title">
                  {translate(
                    `${I18N_BASE_PATH}.groupStructure.cards.groupStructureStatistics.title`,
                    'Group structure statistics'
                  )}
                </p>
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                <strong>
                  {translate(
                    `${I18N_BASE_PATH}.groupStructure.cards.groupStructureStatistics.columns.group`,
                    'Group'
                  )}
                </strong>
              </Col>
              <Col span={14}>
                {companyLinksData.countCompanies ? (
                  <span>
                    {companyLinksData.countCompanies}
                    {translate(
                      `${I18N_BASE_PATH}.groupStructure.cards.groupStructureStatistics.columns.group.companiesIn`,
                      ' companies in '
                    )}
                    {companyLinksData.countCountries}
                    {translate(
                      `${I18N_BASE_PATH}.groupStructure.cards.groupStructureStatistics.columns.group.countries`,
                      ' countries'
                    )}
                  </span>
                ) : (
                  '-'
                )}
              </Col>
            </Row>
          </Row>
        </Col>
        <Col span={12} className="company-link-group-col">
          <Row className="company-link-group-card">
            <Row>
              <Col span={24}>
                <p className="title">
                  {translate(
                    `${I18N_BASE_PATH}.groupStructure.cards.groupStructureSummary.title`,
                    'Group structure summary'
                  )}
                </p>
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                <strong>
                  {translate(
                    `${I18N_BASE_PATH}.groupStructure.cards.groupStructureSummary.columns.holdingCompany`,
                    'Holding Company'
                  )}
                </strong>
              </Col>
              <Col span={14}>
                <span>{companyLinksData.holdingCompanyName}</span>
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                <strong>
                  {translate(
                    `${I18N_BASE_PATH}.groupStructure.cards.groupStructureSummary.columns.ownershipStatus`,
                    'Ownership Status'
                  )}
                </strong>
              </Col>
              <Col span={14}>
                <span>{companyLinksData.ownershipStatus}</span>
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                <strong>
                  {translate(
                    `${I18N_BASE_PATH}.groupStructure.cards.groupStructureSummary.columns.ultimateHoldingCompany`,
                    'Ultimate holding Company'
                  )}
                </strong>
              </Col>
              <Col span={14}>
                <span>{companyLinksData.ultimateHoldingCompanyName}</span>
              </Col>
            </Row>
          </Row>
        </Col>
      </Row>
      <TreeTableCompanyLinks groupStructure={companyLinksData.groupStructure} />
    </aside>
  );
};

const CompanyLink = ({ query, setQuery, companyLinksData }) => {
  const { t: translate } = useTranslation();

  return (
    <section className="KYB-company-link">
      <TabTitle
        icon={KYBCompanyInfo}
        title={translate(`${I18N_BASE_PATH}.title`, 'Company links')}
      />
      <Tabs
        className="wrapper-tabs"
        defaultActiveKey="groupStructure"
        activeKey={query?.subTab}
        onChange={(subTab) => {
          setQuery(() => ({ subTab }));
        }}
        destroyInactiveTabPane
      >
        <TabPane
          tab={translate(`${I18N_BASE_PATH}.groupStructure.title`, 'Group Struture')}
          key="groupStructure"
        >
          <GroupStructure companyLinksData={companyLinksData} />
        </TabPane>
      </Tabs>
    </section>
  );
};

export default CompanyLink;
